var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCasesv2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x31_-outline-expand",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15,21h-2c0-3.907,2.106-7.556,5.498-9.523l1.004,1.73C16.725,14.818,15,17.804,15,21z",
    style: {
      fill: "#3A4249"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.631,35.05l-1.029-1.715C46.729,32.058,48,29.814,48,27.333h2  C50,30.524,48.366,33.408,45.631,35.05z",
    style: {
      fill: "#3A4249"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "24,35 24,20 39,20 41,45 34,35 ",
    style: {
      fill: "#EFBC2E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    style: {
      fill: "#EF941D"
    },
    width: 2,
    x: 37,
    y: 21
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "39.576,27.914 32,25 30,26 29,28 40.22,34.04 ",
    style: {
      fill: "#EF941D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39,21v3l-6-3l-3,5l9.117,4.863c2.665,1.421,5.883-0.51,5.883-3.53V21c0-3.313-2.687-6-6-6H24  c-3.313,0-6,2.687-6,6v10c0,2.209,1.791,4,4,4h8v-6h-6v-8H39z",
    style: {
      fill: "#EFBC2E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,15c-0.158,0-0.314,0.011-0.468,0.023C25.148,17.422,27.889,19,31,19c3.12,0,5.868-1.589,7.482-4  H24z",
    style: {
      fill: "#EF941D"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 10,
    r: 7,
    style: {
      fill: "#EFBC2E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "45,61 38,61 34,47 33,38 33,48 30,61 22,61 25,46 24,35 36.29,31.93 40.22,34.04 41,45 ",
    style: {
      fill: "#EFBC2E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.382,11 60.105,12.447 61.895,11.553 61.118,10 61.895,8.447 60.105,7.553 59.382,9   55.414,9 58.22,6.195 59.755,6.707 60.388,4.809 58.74,4.26 58.19,2.612 56.294,3.245 56.806,4.78 54,7.586 54,3.618 55.447,2.895   54.553,1.105 53,1.882 51.447,1.105 50.553,2.895 52,3.618 52,7.586 49.194,4.781 49.706,3.245 47.81,2.612 47.26,4.26   45.612,4.809 46.245,6.707 47.78,6.195 50.585,9 46.618,9 45.895,7.553 44.105,8.447 44.882,10 44.105,11.553 45.895,12.447   46.618,11 50.585,11 47.779,13.806 46.245,13.294 45.612,15.191 47.26,15.74 47.81,17.388 49.706,16.755 49.194,15.22 52,12.414   52,16.382 50.553,17.105 51.447,18.895 53,18.118 54.553,18.895 55.447,17.105 54,16.382 54,12.414 56.806,15.22 56.294,16.755   58.19,17.388 58.74,15.74 60.388,15.191 59.755,13.294 58.22,13.806 55.414,11 ",
    style: {
      fill: "#62C4C3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "17.382,47 18.105,48.447 19.895,47.553 19.118,46 19.895,44.447 18.105,43.553 17.382,45   13.414,45 16.22,42.195 17.755,42.707 18.388,40.809 16.74,40.26 16.19,38.612 14.294,39.245 14.806,40.78 12,43.586 12,39.618   13.447,38.895 12.553,37.105 11,37.882 9.447,37.105 8.553,38.895 10,39.618 10,43.586 7.194,40.781 7.706,39.245 5.81,38.612   5.26,40.26 3.612,40.809 4.245,42.707 5.78,42.195 8.585,45 4.618,45 3.895,43.553 2.105,44.447 2.882,46 2.105,47.553   3.895,48.447 4.618,47 8.585,47 5.779,49.806 4.245,49.294 3.612,51.191 5.26,51.74 5.81,53.388 7.706,52.755 7.194,51.22   10,48.414 10,52.382 8.553,53.105 9.447,54.895 11,54.118 12.553,54.895 13.447,53.105 12,52.382 12,48.414 14.806,51.22   14.294,52.755 16.19,53.388 16.74,51.74 18.388,51.191 17.755,49.294 16.22,49.806 13.414,47 ",
    style: {
      fill: "#62C4C3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "47.707,50.707 46.293,49.293 47.586,48 45.586,46 47.586,44 45.586,42 47.586,40   46.293,38.707 47.707,37.293 50.414,40 48.414,42 50.414,44 48.414,46 50.414,48 ",
    style: {
      fill: "#3A4249"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "12.707,33.707 11.293,32.293 12.586,31 10.586,29 12.586,27 10.586,25 13.293,22.293   14.707,23.707 13.414,25 15.414,27 13.414,29 15.414,31 ",
    style: {
      fill: "#3A4249"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 7,
    style: {
      fill: "#EF941D"
    },
    width: 2,
    x: 24,
    y: 22
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "30,29 30,35 24,35 24.182,37 32,37 32,29 ",
    style: {
      fill: "#EF941D"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCasesv2);
export default __webpack_public_path__ + "static/media/casesv2.6266dce70439453b60e816583ef64dcf.svg";
export { ForwardRef as ReactComponent };